// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__38k01","inner":"Footer_inner__NwEeo","nextIcon":"Footer_nextIcon__INiYX","innerLeft":"Footer_innerLeft__1yeBM"};